var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-field",
        {
          attrs: {
            label: _vm.label,
            message: _vm.message,
            type: _vm.message ? "is-danger" : ""
          }
        },
        [
          _c(
            "sc-select",
            {
              staticClass: "form-control",
              on: { input: _vm.onChange },
              model: {
                value: _vm.selectedOption,
                callback: function($$v) {
                  _vm.selectedOption = $$v
                },
                expression: "selectedOption"
              }
            },
            [
              !this.fieldSchema.required || !this.fieldSchema.default
                ? _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v("Escolha uma opção")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.fieldSchema.choices, function(choice) {
                return _c("option", { domProps: { value: choice.name } }, [
                  _vm._v(
                    "\n\n        " +
                      _vm._s(choice.title ? choice.title : choice.name) +
                      "\n\n      "
                  )
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("app-config-form", {
        ref: "appConfigForm",
        attrs: { schemaBased: _vm.selectedSchemaBased }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c129136", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c129136","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/modal/components/ChoiceField.vue
// module id = null
// module chunks = 